<script setup lang="ts">
import {useMediaVideoCapture} from "~/composables/studio/useMediaVideoCapture";

const { countdownDisplay, maxRecordMinutes } = useMediaVideoCapture()
const displayElement = ref<HTMLDivElement|null>(null)
</script>

<template>
  <div class="absolute top-0 left-0 bg-black/70 w-full h-full flex items-center justify-center">
    <div class="text-white text-center">
      <div class="text-white mb-6 text-[20rem] leading-none" ref="displayElement">{{ countdownDisplay }}</div>
      <div class="bg-red rounded-full py-1 px-3">{{ $t('capture.max_duration') }} {{ maxRecordMinutes }}:00</div>
    </div>
  </div>
</template>